import { render, staticRenderFns } from "./QuotationListItem.vue?vue&type=template&id=f28ea40a&"
import script from "./QuotationListItem.vue?vue&type=script&lang=js&"
export * from "./QuotationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports